import { Component, OnInit, EventEmitter, OnDestroy } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import { MaterializeAction, MaterializeDirective, toast } from 'angular2-materialize';
import { DatePipe } from '@angular/common';

import { TranService, TranType, TransactionId } from '../../services/tran.service';
import { WarehouseService } from '../../services/warehouse.service';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { CatalogsSettingsService } from '../../services/catalogs-settings.service';
import * as _ from 'lodash';
import * as moment from 'moment';
import { Subscription } from 'rxjs';
import { PermissionService } from '../../services/permission.service';
import { AuthService } from '../../services/auth.service';
import { SelectOption } from '../../globals';

@Component({
  selector: 'app-read-out-tran',
  templateUrl: './read-out-tran.component.html',
  styleUrls: ['./read-out-tran.component.css']
})
export class ReadOutTranComponent implements OnInit, OnDestroy {
  allowed: boolean = false;
  permission: any = {};

  transaction$: Observable<any[]>;
  transactions: any;

  wareId: string = '';

  modalActionsWarehouse = new EventEmitter<string|MaterializeAction>();
  modalParamsWarehouse = [{dismissible: true}];

  warehouses = {};
  wareSelect: SelectOption[] = [];

  // -------- Code for filter, search and pagination --------
  data:Array<any>;
  rows:Array<any> = [];
  columns:Array<any> = [
    {title: 'Fecha', name: "date", sort: 'desc'},
    {title: 'Folio', name: "folio"},
    {title: 'Almacén', name: 'warehouse'},
    {title: 'Tipo de salida', name: 'outType'},
    {title: 'Orden de producción', name: 'odpNames'},
    {title: 'Observaciones', name: 'observations'},
    { title: 'Acciones',  name: 'actionGroup', sort: false, actions: { type: 'group', buttons: [
      { name: 'edit', title: '', styleIcon: 'visibility', action: 'viewTransaction',
        styleClass: 'btn-floating btn waves-effect blue darken-1' }
  ] } }
  ];
  page: number = 1;
  itemsPerPage: number = 5;
  maxSize: number = 5;
  numPages: number = 1;
  length: number = 0;

  config:any = {
    paging: true,
    sorting: {columns: this.columns},
    filtering: {filterString: ''},
    api: {
      viewTransaction: this.viewTransaction.bind(this)
    }
  };

  subs: Subscription[] = [];

  constructor(
    private service: TranService,
    private warehouseService: WarehouseService,
    private settings: CatalogsSettingsService,
    private fb: FormBuilder,
		private permissionService: PermissionService,
    private authService: AuthService,
    private router: Router
  ) {
    let permissionsSubs = this.permissionService.getUserPermissionByEmail(this.authService.currentUser['email']).subscribe((groups) => {
        permissionsSubs.unsubscribe();
        this.permission = this.permissionService.constructPermissionObject(groups, 'outTran');
        if(!this.permission || !this.permission.readAction) this.router.navigate(['/']);
        else this.allowed = true;
    });

    let subSet = this.settings.getPayrollSettings('1').subscribe(setting => {
      this.itemsPerPage = setting.tableQuantity;
      subSet.unsubscribe();
    });
    this.subs.push(
      this.service.getTransactions().subscribe(tempTransactions => {
        this.transactions = tempTransactions.filter(({type}) => type == TranType.Out).map((tran: any) => {
          tran.outType = tran.inOutTypeObj.description;
          tran.warehouse = tran.warehouseObj.name;
          tran.odpNames = '';
          this.getTranData(tran);
          return tran;
        });
        this.data = this.transactions;
        this.length = this.data.length;
        this.onChangeTable(this.config);
      })
    );
    this.subs.push(
      this.warehouseService.getWarehouses().subscribe(warehouses => {
        let select: SelectOption[] = [];
        warehouses.map(ware => {
          select.push({name: ware.name, value: ware.id});
        });
        this.wareSelect = select;
        this.wareId = this.wareSelect[0].value;
      })
    );
  }

  ngOnInit() {
  }
  ngOnDestroy(){
    this.subs.map((sub, index) => {
      this.subs[index].unsubscribe();
    });
  }

  onCreate(){
    if(!this.permission.createAction) return toast('No tiene los permisos para crear.', 2000);
    this.openModalWarehouse();
  }
  
  async getTranData(inTran: TransactionId){
    let tranOdpNames: string[] = [];
    for(let pr of inTran.prInTransaction){
      if(pr.odpName) tranOdpNames.push(pr.odpName);
    }
    inTran['odpNames'] = [...new Set(tranOdpNames)].join(', ');
  }

  addWarehouse(){
    this.closeModalWarehouse();
    this.router.navigate([`/new_out_tran/${this.wareId}`]);
  }
  

  openModalWarehouse() {
    this.modalActionsWarehouse.emit({ action: 'modal', params: ['open'] });
  }

  closeModalWarehouse() {
    this.modalActionsWarehouse.emit({ action: 'modal', params: ['close'] });
  }

  viewTransaction(data: any): any {
    this.router.navigate(['/vw_tran/' + data.row.id]);
  }

  /*********** Filter, sort, and pagination */
  onChangeTable(config:any, page:any = {page: this.page, itemsPerPage: this.itemsPerPage}):any {
    if (config.filtering) {
      Object.assign(this.config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.config.sorting, config.sorting);
    }
    let filteredData = this.changeFilter(this.data, this.config);
    let sortedData = this.changeSort(filteredData, this.config);
    this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
    this.length = sortedData.length;
  }
  changeFilter(data:any, config:any):any {
    let filteredData:Array<any> = data;
    this.columns.forEach((column:any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item:any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });

    if (!config.filtering) {
      return filteredData;
    }

    if (config.filtering.columnName) {
      return filteredData.filter((item:any) => item[config.filtering.columnName].match(this.config.filtering.filterString));
    }

    let tempArray:Array<any> = [];
    filteredData.forEach((item:any) => {
      let flag = false;
      this.columns.forEach((column:any) => {
        if (item[column.name] && item[column.name].toString().toLowerCase().match(this.config.filtering.filterString.toLowerCase())) {
          flag = true;
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }
  changeSort(data:any, config:any):any {
    if (!config.sorting) {
      return data;
    }

    let columns = this.config.sorting.columns || [];
    let columnName:string;
    let sort:string;

    for (let i = 0; i < columns.length; i++) {
      if (columns[i].sort !== undefined && columns[i].sort !== '' && columns[i].sort !== false) {
        columnName = columns[i].name;
        sort = columns[i].sort;
      }
    }

    if (!columnName) {
      return data;
    }

    // simple sorting
    return data.sort((previous:any, current:any) => {
      if (previous[columnName] > current[columnName]) {
        return sort === 'desc' ? -1 : 1;
      } else if (previous[columnName] < current[columnName]) {
        return sort === 'asc' ? -1 : 1;
      }
      return 0;
    });
  }
  changePage(page:any, data:Array<any> = this.data):Array<any> {
    let start = (page.page - 1) * page.itemsPerPage;
    let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;
    return data.slice(start, end);
  }

}
